import { MatchPreference } from "PFTypes";
import React from "react";

import { MatchedPreference } from "./matched_preference";

type MatchedPreferencesProps = { matches?: MatchPreference[] };

export const MatchedPreferences = ({ matches }: MatchedPreferencesProps) => (
  <>
    {(matches || []).map((match) => (
      <MatchedPreference match={match} key={`preference-${match}`} />
    ))}
  </>
);
